export const TAKING_SURVEY = 'TAKING_SURVEY';
